export default __webpack_public_path__ + "static/media/Mockup-min.d8c942ee.png";